import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate2_5x.svg'

export const IconPlaybackRate2_5x = IconSVG as IconComponent
